"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _cache = _interopRequireDefault(require("../util/cache"));

var DataSync = _interopRequireWildcard(require("../util/DataSync"));

var Log = _interopRequireWildcard(require("../util/Log"));

var Events = _interopRequireWildcard(require("../../definitions/Events"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * A published Stream
 * @public
 */
var Remote =
/*#__PURE__*/
function () {
  /**
   * @access protected
   * @param {object} values
   */
  function Remote(values) {
    _classCallCheck(this, Remote);

    Log.d('Remote~new', values);
    /**
     * The uid of the room the stream is published in
     * @type {string}
     */

    this.roomId = values.roomId;
    /**
     * The uid of this stream
     * @type {string}
     */

    this.uid = values.uid;
    /**
     * The uid of the publisher of the stream
     * @type {string}
     */

    this.from = values.from;
    /**
     * The type of the stream
     * @type {string}
     */

    this.type = values.type;
    /**
     * @type {string}
     */

    this.device = values.device;
    /**
     * the user agent of the publisher of the stream
     * @type {string}
     */

    this.userAgent = values.userAgent;
    /**
     * @type {string}
     */

    this.height = values.height;
    /**
     * @type {string}
     */

    this.width = values.width;
    /**
     * The local DOM container element where the {@link Local~media} is displayed
     * @type {Element}
     */

    this.container = _cache.default.config.remoteStreamContainer;
    /**
     * @type {{audio: boolean, video: boolean}}
     */

    this.muted = Object.assign({
      audio: false,
      video: false
    }, values.muted);
    /**
     * List of callbacks for mute status change
     * @type {{MUTE: function[]}}
     * @private
     */

    this._callbacks = {};
    /**
     * PeerConnections associated to this remote stream
     * @type {PeerConnection}
     */

    this.peerConnection = null;
  }
  /**
   * DOM element where the MediaStream is displayed
   * @returns {Element}
   */


  _createClass(Remote, [{
    key: "subscribe",

    /**
     * Subscribe to the stream
     * @param {Element} [remoteStreamContainer] The element the stream is attached to.
     * Can be null if already specified in ReachConfig.
     * @returns {Promise}
     */
    value: function subscribe(remoteStreamContainer) {
      var _this = this;

      if (!_cache.default.user) {
        return Promise.reject(new Error('Only an authenticated user can subscribe to a Room\'s stream.'));
      } // TODO: Test if not already subscribed ?


      this.container = remoteStreamContainer || _cache.default.config.remoteStreamContainer;
      Log.d('Remote~subscribe', this.container);
      return _cache.default.peerConnections.answer(this, this.container, this._callbacks[Events.stream.WEBRTC_ERROR]).then(function (pc) {
        _this.peerConnection = pc;
      }).then(function () {
        return DataSync.update("_/rooms/".concat(_this.roomId, "/subscribers/").concat(_this.uid, "/").concat(_cache.default.device), {
          to: _cache.default.user.uid,
          _created: DataSync.ts()
        });
      }).then(function () {
        DataSync.onDisconnect("_/rooms/".concat(_this.roomId, "/subscribers/").concat(_this.uid, "/").concat(_cache.default.device)).remove();
        var subscribed = false;
        DataSync.on("_/rooms/".concat(_this.roomId, "/streams/").concat(_this.uid), 'value', function (snapData) {
          var values = snapData.val();
          Log.d('Remote~updated', values);

          if (values) {
            // Update type
            _this.type = values.type; // update stream size

            var width = values.width,
                height = values.height;

            if ((height || width) && (height !== _this.height || width !== _this.height)) {
              _this.height = values.height;
              _this.width = values.width;
              Log.w(_this._callbacks[Events.stream.SIZE]);
              (_this._callbacks[Events.stream.SIZE] || []).forEach(function (cb) {
                return cb(_this.height, _this.width);
              });
            } // Update mute status


            var muted = values.muted;

            if (muted && (muted.audio !== _this.muted.audio || muted.video !== _this.muted.video)) {
              _this.muted = muted;
              Log.w(_this._callbacks[Events.stream.MUTE]);
              (_this._callbacks[Events.stream.MUTE] || []).forEach(function (cb) {
                return cb(_this.muted);
              });
            }

            subscribed = true;
          } else if (subscribed) {
            Log.i('Remote#removed', _this);

            _this._close(true);
          }
        });
      }).catch(Log.r('Remote~subscribe'));
    }
    /**
     * Unsubscribe from the stream
     * @returns {Promise}
     */

  }, {
    key: "unSubscribe",
    value: function unSubscribe() {
      return this._close(false);
    }
    /**
     * Close the remote Stream
     * @param {boolean} remote Close is initiated by publisher
     * @returns {*}
     * @private
     */

  }, {
    key: "_close",
    value: function _close(remote) {
      // Cancel onDisconnect
      DataSync.onDisconnect("_/rooms/".concat(this.roomId, "/subscribers/").concat(this.uid, "/").concat(_cache.default.device)).cancel(); // Stop listening to stream modifications

      DataSync.off("_/rooms/".concat(this.roomId, "/streams/").concat(this.uid), 'value'); // Un-subscribe

      if (!remote) {
        DataSync.remove("_/rooms/".concat(this.roomId, "/subscribers/").concat(this.uid, "/").concat(_cache.default.device));
      } // Close PeerConnection


      return Promise.resolve(_cache.default.peerConnections.close(this.uid, this.device));
    }
    /**
     * Register a callback for a specific event
     * @param {string} event The event name ({@link Events/Stream})
     * @param {function} callback The callback for the event
     */

  }, {
    key: "on",
    value: function on(event, callback) {
      if (Events.stream.supports(event)) {
        if (!this._callbacks[event]) {
          this._callbacks[event] = [];
        }

        this._callbacks[event].push(callback);
      }
    }
    /**
     * Register a callback for a specific event
     * @param {string} [event] The event name ({@link Events/Stream})
     * @param {function} [callback] The callback for the event
     */

  }, {
    key: "off",
    value: function off(event, callback) {
      if (!event) {
        this._callbacks = {};
      } else if (Events.stream.supports(event)) {
        if (!callback) {
          this._callbacks[event] = [];
        } else {
          this._callbacks[event] = this._callbacks[event].filter(function (cb) {
            return cb !== callback;
          });
        }
      }
    }
    /**
     * @access protected
     * @param {object} values
     */

  }, {
    key: "update",
    value: function update(values) {
      var _this2 = this;

      Object.keys(values).forEach(function (key) {
        _this2[key] = values[key];
      });
    }
  }, {
    key: "node",
    get: function get() {
      return this.peerConnection ? this.peerConnection.node : null;
    }
  }]);

  return Remote;
}();

exports.default = Remote;